import { Outlet } from "react-router-dom";
import { TitleManager } from "@/components/title-manager";

export function RootLayout() {
  return (
    <>
      <TitleManager />
      <Outlet />
    </>
  );
}
